export default __webpack_public_path__ + "static/media/enviro_all.1644b910.png";